import { configureStore } from "@reduxjs/toolkit";
import { eventModelSlice } from "./slice/EventModelSlice";
import {contactAlertFileMetadataComponentSlice} from "src/state/slice/ContactAlertFileMetadataSlice";

/**
 * Redux store for this app. Different state objects can be added here.
 */
export const store = configureStore({
  reducer: {
    eventModel: eventModelSlice.reducer,
    contactAlertFileMetadataComponent: contactAlertFileMetadataComponentSlice.reducer
  }
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
